import React from "react";
import { AlertTriangle, CheckCircle2, RefreshCw, Wifi, WifiOff } from "lucide-react";

function formatDateTime(value) {
  if (!value) return "Sin sincronizacion aun";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin sincronizacion aun";
  return new Intl.DateTimeFormat("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export default function OfflineBanner({ status }) {
  if (!status) return null;

  const { browserOnline, supabaseReachable, online, checkedAt, lastSyncAt } = status;
  const isHealthy = online;

  const toneClass = isHealthy
    ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-100"
    : "border-amber-500/30 bg-amber-500/10 text-amber-100";

  const icon = isHealthy ? <Wifi className="h-4 w-4" /> : <WifiOff className="h-4 w-4" />;
  const label = isHealthy ? "Conexion activa" : "Modo sin conexion";

  return (
    <div className={`mb-3 rounded-md border px-3 py-2 text-sm ${toneClass}`}>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          {icon}
          <span className="font-medium">{label}</span>
          {!browserOnline ? (
            <span className="inline-flex items-center gap-1 text-xs opacity-90">
              <AlertTriangle className="h-3.5 w-3.5" />
              Navegador sin red
            </span>
          ) : !supabaseReachable ? (
            <span className="inline-flex items-center gap-1 text-xs opacity-90">
              <RefreshCw className="h-3.5 w-3.5" />
              Supabase no responde
            </span>
          ) : (
            <span className="inline-flex items-center gap-1 text-xs opacity-90">
              <CheckCircle2 className="h-3.5 w-3.5" />
              Cache actualizada
            </span>
          )}
        </div>

        <div className="flex flex-col gap-0.5 text-xs sm:items-end">
          <span>Ultima sincronizacion: {formatDateTime(lastSyncAt)}</span>
          <span className="opacity-80">
            Verificacion: {formatDateTime(checkedAt)}
          </span>
        </div>
      </div>
    </div>
  );
}

